import { createFileRoute } from "@tanstack/react-router";
import Home from "@landingClient/pages/Home";

export const Route = createFileRoute("/")({
  component: Home,
});
